import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const PayslipProcessingMessage = ({ messageInfo, formatDate }) => {
  const { processmilestones } = useSelector((state) => state.milestones);
  const [milestoneId, setMilestoneId] = useState(null);
  const [processId, setProcessId] = useState(null);
  const getSubmitOutputToCustomerTask = (processmilestones) => {
    if (!processmilestones || !Array.isArray(processmilestones)) {
      return;
    }
    const result = processmilestones.find((item) =>
      item.taskData?.some((t) => t.name === "Submit output to Customer"),
    );
    setMilestoneId(result?.id);
    setProcessId(result?.process);
  };

  useEffect(() => {
    if (processmilestones) {
      getSubmitOutputToCustomerTask(processmilestones);
    }
  }, [processmilestones]);

  const header =
    messageInfo?.related_object_type === "PAYSLIP_PROCESSING"
      ? "The file/s uploaded are processing"
      : "The file you uploaded has been submitted";
  return (
    <div className="message-container">
      <Avatar
        icon={
          messageInfo?.related_object_type === "PAYSLIP_PROCESSING"
            ? "pi pi-exclamation-circle"
            : "pi pi-check-circle"
        }
        shape="square"
        className={
          messageInfo?.related_object_type === "PAYSLIP_PROCESSING"
            ? "payslip-processing-message"
            : "payslip-submitted-message"
        }
      />
      <div className="message-content gap-0">
        <div className="meta-info">
          <p className="user-name"> {header} </p>
          <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
        </div>
        {messageInfo?.content && (
          <p className="message">
            {messageInfo?.content}
            {messageInfo?.related_object_type === "PAYSLIP_SUBMITTED" && (
              <Link
                to={`/process/${processId}/milestones?milestoneId=${milestoneId}`}
                className="conversation_link"
              >
                View Milestone
              </Link>
            )}
          </p>
        )}
      </div>
    </div>
  );
};

PayslipProcessingMessage.proptypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
};

export default PayslipProcessingMessage;
